var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRegistered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "academiconsPreregistered0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "academiconsPreregistered1",
    fill: "#747b26",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.035,
    d: "M255.967 8c-14.42 0-28.913 3.167-39.842 9.51L69.402 102.207c-21.954 12.675-39.899 43.754-39.899 69.084v169.42c0 25.336 17.945 56.425 39.9 69.094l146.722 84.714c10.929 6.324 25.421 9.482 39.842 9.482c14.486 0 28.97-3.158 39.9-9.482l146.722-84.714c21.922-12.669 39.908-43.758 39.908-69.094V171.29c0-25.33-17.986-56.41-39.908-69.084L295.866 17.511C284.937 11.167 270.453 8 255.967 8Zm99.189 144.373c4.227 0 8.45 1.602 11.651 4.813l17.847 17.827c6.402 6.428 6.402 16.938 0 23.36L228.22 354.823c-6.466 6.416-16.938 6.416-23.34 0l-68.942-68.913c-6.402-6.415-5.044-18.277 0-23.34l17.855-17.828c6.403-6.428 16.94-6.428 23.341 0l27.746 27.726c6.402 6.415 16.874 6.415 23.34 0l115.236-115.282a16.556 16.556 0 0 1 11.699-4.813z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRegistered);
export default __webpack_public_path__ + "static/media/ic_registered.2484e9d1000dcdd0d106313aafd2cbaf.svg";
export { ForwardRef as ReactComponent };